var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$i18n.locale},[(_vm.isLoading)?_c('div',[_vm._m(0)]):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"overlay"}},[_c('div',{staticClass:"loader"})])
}]

export { render, staticRenderFns }